/**
 * gamesis Story API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const State = {
    Idle: 'idle',
    Action: 'action',
    Message: 'message'
} as const;
export type State = typeof State[keyof typeof State];

